import { api } from './api';

export interface DashboardTransaction {
  id: string;
  dealAmount: number;
  exclusiveArea: number;
  dealYear: number;
  dealMonth: number;
  dealDay: number;
  floor: string | null;
  property: {
    id: string;
    complexName: string;
    dongtanArea: string | null;
  };
}

export interface DashboardPriceChange {
  id: string;
  listingId?: string;
  oldPrice: number;
  newPrice: number;
  priceDelta: number;
  changePercent: number;
  detectedAt: string;
  complexName: string;
  propertyId: string;
  dongtanArea: string | null;
  exclusiveArea: number | null;
  floor: string | null;
}

export interface UndervaluedItem {
  listingId: string;
  propertyId: string;
  complexName: string;
  dongtanArea: string | null;
  askingPrice: number;
  referencePrice: number;
  discount: number;
  score: number;
  exclusiveArea: number | null;
  floor: string | null;
}

export interface AIPredictionItem {
  propertyId: string;
  complexName: string;
  dongtanArea: string | null;
  currentPrice: number;
  predictedPrice: number;
  changeRate: number;
  confidence: number;
  buildYear: number | null;
  totalUnits: number | null;
}

export interface TrendingComplexItem {
  propertyId: string;
  complexName: string;
  dongtanArea: string | null;
  transactionCount: number;
  avgPrice: number;
  priceChange: number;
  heatScore: number;
  totalUnits: number | null;
  buildYear: number | null;
}

export interface HomeDashboardData {
  counts: {
    totalProperties: number;
    totalTransactions: number;
    activeListings: number;
  };
  marketKPI: {
    avgPrice: number;
    avgPriceChange: number;
    medianPrice: number;
    transactionCount: number;
    transactionCountPrev: number;
    inventoryCount: number;
    period: string;
  };
  recentTransactions: DashboardTransaction[];
  recentPriceChanges: DashboardPriceChange[];
  areaBreakdown: Record<string, { avgPrice: number; count: number; change: number }>;
  undervalued: {
    stats: {
      totalFound: number;
      avgDiscount: number;
      topDiscount: { complexName: string; discount: number } | null;
    } | null;
    topItems: UndervaluedItem[];
  };
  aiPredictions: AIPredictionItem[];
  trendingComplexes: TrendingComplexItem[];
  aiAnalysisProgress: { analyzed: number; total: number } | null;
}

export async function getHomeDashboard(): Promise<HomeDashboardData> {
  const res = await api.get('/dashboard/home');
  return res.data.data;
}
